<script>
import Notification from '../reUse/Notification.vue';
import { i18n } from '@/i18n'
import sl from '@/Prevodi/PregledPovrsin-sl.json';
import en from '@/Prevodi/PregledPovrsin-en.json';
import it from '@/Prevodi/PregledPovrsin-it.json';
import {config} from "@/config";
export default {
  components: {
    Notification
  },
  data() {
    return {
      // Form state
      prevodi: false,
      prikaz: 'vnos',
      isSubmitting: false,
      dailyDocument: '',
      datum: null,
      validationErrors: {},
      user: config.FullUser,
      // Section A: Aerodrome
      aerodrome: {
        icaoCode: 'LJAJ',
        name: 'Ajdovščina'
      },

      // Section B: Inspection Date/Time
      inspection: {
        date: '',
        time: '',
        utcString: ''
      },

      // Section C: Runway
      runway: {
        designation: '26-08',
        threshold1: '',
        threshold2: ''
      },

      // Section 1: Surface Conditions
      surfaceConditions: {
        areas: {
          all: false,
          runwayThirds: {I: false, II: false, III: false},
          taxiways: {A: false, B: false, C: false},
          aprons: {apron: false}
        },
        conditions: {
          dryClean: {
            selected: false,
            areas: {
              all: false,
              runwayThirds: {I: false, II: false, III: false},
              taxiways: {A: false, B: false, C: false},
              aprons: {apron: false}
            }
          },
          damp: {
            selected: false,
            areas: {
              all: false,
              runwayThirds: {I: false, II: false, III: false},
              taxiways: {A: false, B: false, C: false},
              aprons: {apron: false}
            }
          },
          wet: {
            selected: false,
            areas: {
              all: false,
              runwayThirds: {I: false, II: false, III: false},
              taxiways: {A: false, B: false, C: false},
              aprons: {apron: false}
            }
          },
          puddles: {
            selected: false,
            areas: {
              all: false,
              runwayThirds: {I: false, II: false, III: false},
              taxiways: {A: false, B: false, C: false},
              aprons: {apron: false}
            }
          },
          waterLayer: {
            selected: false,
            areas: {
              all: false,
              runwayThirds: {I: false, II: false, III: false},
              taxiways: {A: false, B: false, C: false},
              aprons: {apron: false}
            }
          }
        }
      },

      // Section 3: Deficiencies
      deficiencies: {
        surfaceDamage: {
          status: 'OK',
          location: '',
          areas: {
            all: false,
            runwayThirds: {I: false, II: false, III: false},
            taxiways: {A: false, B: false, C: false},
            aprons: {apron: false}
          },
          description: ''
        },
        foreignObjects: {
          status: 'OK',
          location: '',
          areas: {
            all: false,
            runwayThirds: {I: false, II: false, III: false},
            taxiways: {A: false, B: false, C: false},
            aprons: {apron: false}
          },
          description: ''
        },
        unevenness: {
          status: 'OK',
          location: '',
          areas: {
            all: false,
            runwayThirds: {I: false, II: false, III: false},
            taxiways: {A: false, B: false, C: false},
            aprons: {apron: false}
          },
          description: ''
        },
        horizontalMarkings: {
          status: 'OK',
          location: '',
          areas: {
            all: false,
            runwayThirds: {I: false, II: false, III: false},
            taxiways: {A: false, B: false, C: false},
            aprons: {apron: false}
          },
          description: ''
        },
        verticalMarkings: {
          status: 'OK',
          location: '',
          areas: {
            all: false,
            runwayThirds: {I: false, II: false, III: false},
            taxiways: {A: false, B: false, C: false},
            aprons: {apron: false}
          },
          description: ''
        },
        safetyStrip: {
          status: 'OK',
          location: '',
          areas: {
            all: false,
            runwayThirds: {I: false, II: false, III: false},
            taxiways: {A: false, B: false, C: false},
            aprons: {apron: false}
          },
          description: ''
        },
        other: {
          status: 'OK',
          location: '',
          areas: {
            all: false,
            runwayThirds: {I: false, II: false, III: false},
            taxiways: {A: false, B: false, C: false},
            aprons: {apron: false}
          },
          description: ''
        }
      },

      // Section 4: Obstacles
      obstacles: {
        present: false,
        areas: {
          all: false,
          runwayThirds: {I: false, II: false, III: false},
          taxiways: {A: false, B: false, C: false},
          aprons: {apron: false}
        },
        details: {movable: [], immovable: [], notInAIP: [], descriptions: ''},
        location: {coordinates: '', reference: '', distance: '', height: ''}
      },

      // Section 5: Birds
      birds: {
        present: false,
        areas: {
          all: false,
          runwayThirds: {I: false, II: false, III: false},
          taxiways: {A: false, B: false, C: false},
          aprons: {apron: false}
        },
        details: {species: '', count: '', behavior: '', flightDirection: '', altitude: '', timeOfDay: '', weather: ''},
        location: {specificArea: '', distance: '', height: ''},
        impact: {onOperations: false, riskLevel: '', mitigation: ''}
      },

      // Section 6: Remarks
      remarks: {
        general: '',
        detailedDeficiencies: '',
        operationalNotes: '',
        weatherConditions: '',
        inspectorNotes: '',
        recommendations: '',
        followUpRequired: false,
        followUpDate: '',
        priority: '',
        attachments: [],
        remark: '',
        areas: {
          all: false,
          runwayThirds: {I: false, II: false, III: false, IRemark: '', IIRemark: '', IIIRemark: ''},
          taxiways: {A: false, B: false, C: false, ARemark: '', BRemark: '', CRemark: ''},
          aprons: {apron: false, Remark: ''}
        }
      },

      // Section 7: Helicopter Pads
      helicopterPads: {
        inspected: false,
        areas: {
          all: false,
          airTaxiway: {airTaxiway: false, airTaxiwayRemark: ''},
          helipad: {helipad: false, helipadRemark: ''},
          lights: {lights: false, lightRemark: ''},
          helipadAccessRoad: {helipadAccessRoad: false, helipadAccessRoadRemark: ''}
        },
        details: {padCondition: '', markings: '', lighting: '', obstacles: '', drainage: '', maintenance: ''},
        location: {padNumber: '', coordinates: '', reference: '', dimensions: ''},
        inspection: {date: '', time: '', inspector: '', conditions: '', findings: '', recommendations: ''}
      },

      // Notification
      text: '',
      types: '',
      ShowNoti: false
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    // Auto-fill current date and time
    const now = new Date();
    this.inspection.date = now.toLocaleDateString('sl-SI');
    // this.inspection.time = now.toTimeString().slice(0, 5).replace(':', ''); //brez : vmes
    this.inspection.time = now.toTimeString().slice(0, 5);
    this.datum = now.toISOString().split('T')[0];
    this.getDailyDocument();
  },
  computed: {
    // Get condition labels
    conditionLabels() {
      return {
        dryClean: this.$t('conditions.dryClean'),
        damp: this.$t('conditions.damp'),
        wet: this.$t('conditions.wet'),
        puddles: this.$t('conditions.puddles'),
        waterLayer: this.$t('conditions.waterLayer')
      };
    },

    // Get deficiency labels
    deficiencyLabels() {
      return {
        surfaceDamage: this.$t('deficiency.surfaceDamage'),
        foreignObjects: this.$t('deficiency.foreignObjects'),
        unevenness: this.$t('deficiency.unevenness'),
        horizontalMarkings: this.$t('deficiency.horizontalMarkings'),
        verticalMarkings: this.$t('deficiency.verticalMarkings'),
        safetyStrip: this.$t('deficiency.safetyStrip'),
        other: this.$t('deficiency.other')
      };
    },

    // Check if any area is selected for a condition
    isAnyAreaSelected(conditionKey) {
      if (typeof conditionKey === 'string') {
        const condition = this.surfaceConditions.conditions[conditionKey];
        return condition.areas.runwayThirds.I ||
            condition.areas.runwayThirds.II ||
            condition.areas.runwayThirds.III ||
            condition.areas.taxiways.A ||
            condition.areas.taxiways.B ||
            condition.areas.taxiways.C ||
            condition.areas.aprons.apron;
      }
      return false;
    },

  },
  methods: {
    getDailyDocument() {
      // const now = new Date();
      var podatki = new URLSearchParams();
      // podatki.append('datum', now.toDateString());
      podatki.append('datum', this.datum);
      podatki.append('icao', 'LJAJ'); //TODO variabilno
      axios.post('./api/pregledi/povrsina/izpis/', podatki, {withCredentials: true}).then((response) => {
        if (response.data.datoteka !== "") {
          this.dailyDocument = "";
          setTimeout(() => {
            this.dailyDocument = response.data.datoteka;
          }, 100);

        } else {
          this.dailyDocument = "";
        }
        if (this.dailyDocument !== '') {
          this.prikaz = 'zapisi';
        }
      }).catch((napaka) => {
        this.text = this.$t('obvestila.napakaBranja');
        this.types = 'error';
        this.ShowNoti = true;
      });
    },
    CheckDate() {
      this.getDailyDocument();
    },
    // Toggle "all" checkbox for conditions
    toggleAllAreas(conditionKey) {
      const condition = this.surfaceConditions.conditions[conditionKey];
      const allSelected = condition.areas.all;

      if (allSelected) {
        condition.areas.runwayThirds.I = true;
        condition.areas.runwayThirds.II = true;
        condition.areas.runwayThirds.III = true;
        condition.areas.taxiways.A = true;
        condition.areas.taxiways.B = true;
        condition.areas.taxiways.C = true;
        condition.areas.aprons.apron = true;
      } else {
        condition.areas.runwayThirds.I = false;
        condition.areas.runwayThirds.II = false;
        condition.areas.runwayThirds.III = false;
        condition.areas.taxiways.A = false;
        condition.areas.taxiways.B = false;
        condition.areas.taxiways.C = false;
        condition.areas.aprons.apron = false;
      }
    },

    // Toggle "all" checkbox for deficiencies
    toggleAllAreasDeficiency(deficiencyKey) {
      const deficiency = this.deficiencies[deficiencyKey];
      const allSelected = deficiency.areas.all;

      if (allSelected) {
        deficiency.areas.runwayThirds.I = true;
        deficiency.areas.runwayThirds.II = true;
        deficiency.areas.runwayThirds.III = true;
        deficiency.areas.taxiways.A = true;
        deficiency.areas.taxiways.B = true;
        deficiency.areas.taxiways.C = true;
        deficiency.areas.aprons.apron = true;
      } else {
        deficiency.areas.runwayThirds.I = false;
        deficiency.areas.runwayThirds.II = false;
        deficiency.areas.runwayThirds.III = false;
        deficiency.areas.taxiways.A = false;
        deficiency.areas.taxiways.B = false;
        deficiency.areas.taxiways.C = false;
        deficiency.areas.aprons.apron = false;
      }
    },

    // Toggle "all" checkbox for other sections
    toggleAllAreasSection(section) {
      const data = this[section];
      const allSelected = data.areas.all;

      if (section !== 'helicopterPads') {
        if (allSelected) {
          data.areas.runwayThirds.I = true;
          data.areas.runwayThirds.II = true;
          data.areas.runwayThirds.III = true;
          data.areas.taxiways.A = true;
          data.areas.taxiways.B = true;
          data.areas.taxiways.C = true;
          data.areas.aprons.apron = true;
        } else {
          data.areas.runwayThirds.I = false;
          data.areas.runwayThirds.II = false;
          data.areas.runwayThirds.III = false;
          data.areas.taxiways.A = false;
          data.areas.taxiways.B = false;
          data.areas.taxiways.C = false;
          data.areas.aprons.apron = false;
        }
      } else {
        if (allSelected) {
          data.areas.airTaxiway.airTaxiway = false;
          data.areas.helipad.helipad = false;
          data.areas.lights.lights = false;
          data.areas.helipadAccessRoad.helipadAccessRoad = false;
        } else {
          data.areas.airTaxiway.airTaxiway = false;
          data.areas.helipad.helipad = false;
          data.areas.lights.lights = false;
          data.areas.helipadAccessRoad.helipadAccessRoad = false;
        }
      }

    },

    // Check if any area is selected for deficiencies
    isAnyAreaSelectedDeficiency(deficiencyKey) {
      const deficiency = this.deficiencies[deficiencyKey];
      return deficiency.areas.runwayThirds.I ||
          deficiency.areas.runwayThirds.II ||
          deficiency.areas.runwayThirds.III ||
          deficiency.areas.taxiways.A ||
          deficiency.areas.taxiways.B ||
          deficiency.areas.taxiways.C ||
          deficiency.areas.aprons.apron;
    },

    // Check if any area is selected for other sections
    isAnyAreaSelectedSection(section) {
      const data = this[section];
      return data.areas.runwayThirds.I ||
          data.areas.runwayThirds.II ||
          data.areas.runwayThirds.III ||
          data.areas.taxiways.A ||
          data.areas.taxiways.B ||
          data.areas.taxiways.C ||
          data.areas.aprons.apron;
    },

    // Validate Section A: Aerodrome
    validateAerodrome() {
      const errors = {};

      if (!this.aerodrome.icaoCode || this.aerodrome.icaoCode.trim() === '') {
        errors.icaoCode = 'ICAO code is required';
      } else if (!/^[A-Z]{4}$/.test(this.aerodrome.icaoCode)) {
        errors.icaoCode = 'ICAO code must be exactly 4 uppercase letters';
      }

      return {
        isValid: Object.keys(errors).length === 0,
        errors: errors
      };
    },

    // Validate Section B: Date/Time
    validateInspectionDateTime() {
      const errors = {};

      if (!this.inspection.date || this.inspection.date.trim() === '') {
        errors.date = 'Inspection date is required';
      } else if (!/^\d{1,2}\S*.\d{1,2}\S*.\d{4}$/.test(this.inspection.date)) {
        errors.date = 'Date must be in DD.MM.YYYY format';
      }

      if (!this.inspection.time || this.inspection.time.trim() === '') {
        errors.time = 'Inspection time is required';
      } else if (!/^\d{2}:\d{2}$/.test(this.inspection.time)) {
        errors.time = 'Time must be in HHMM format';
      }

      return {
        isValid: Object.keys(errors).length === 0,
        errors: errors
      };
    },

    // Validate Section C: Runway
    validateRunwayDesignation() {
      const errors = {};

      if (!this.runway.designation || this.runway.designation.trim() === '') {
        errors.designation = 'Runway designation is required';
      } else if (!/^\d{2}-\d{2}$/.test(this.runway.designation)) {
        errors.designation = 'Runway designation must be in format XX-XX (e.g., 08-26)';
      }

      return {
        isValid: Object.keys(errors).length === 0,
        errors: errors
      };
    },

    // Validate complete form
    validateCompleteForm() {
      const validationResults = {
        aerodrome: this.validateAerodrome(),
        inspection: this.validateInspectionDateTime(),
        runway: this.validateRunwayDesignation()
      };

      const allValid = Object.values(validationResults).every(result => result.isValid);
      const allErrors = Object.values(validationResults).reduce((acc, result) => {
        return {...acc, ...result.errors};
      }, {});

      this.validationErrors = allErrors;

      return {
        isValid: allValid,
        errors: allErrors,
        sections: validationResults
      };
    },

    // Clear validation errors
    clearValidationErrors() {
      this.validationErrors = {};
    },

    // Get validation error for specific field
    getFieldError(field) {
      return this.validationErrors[field] || null;
    },

    // Show validation summary
    showValidationSummary() {
      const validation = this.validateCompleteForm();
      if (!validation.isValid) {
        this.text = this.$t('obvestila.napakaValidacije');
        this.types = 'error';
        this.ShowNoti = true;
        this.ErrorReport('napaka-pregled-povrsin-vnos', null, 'showValidationSummary()', 'pregled-povrsin-vnos', this.text);
      }
      return validation;
    },

    // Clear form
    clearForm() {
      const initial = this.$options.data.call(this);

      this.isSubmitting = false;
      this.validationErrors = {};

      this.aerodrome = initial.aerodrome;
      this.runway = initial.runway;
      this.surfaceConditions = initial.surfaceConditions;
      this.deficiencies = initial.deficiencies;
      this.obstacles = initial.obstacles;
      this.birds = initial.birds;
      this.remarks = initial.remarks;
      this.helicopterPads = initial.helicopterPads;

      const now = new Date();
      this.inspection.date = now.toLocaleDateString('sl-SI');
      this.inspection.time = now.toTimeString().slice(0, 5);
      this.inspection.utcString = '';

      this.clearValidationErrors();
    },

    // Prepare form data for submission
    prepareFormData() {
      return {
        aerodrome: this.aerodrome,
        inspection: this.inspection,
        runway: this.runway,
        surfaceConditions: this.surfaceConditions,
        deficiencies: this.deficiencies,
        obstacles: this.obstacles,
        birds: this.birds,
        remarks: this.remarks,
        helicopterPads: this.helicopterPads
      };
    },

    // Submit form
    async submitForm() {
      this.clearValidationErrors();
      const validation = this.showValidationSummary();

      if (!validation.isValid) {
        return false;
      }

      try {
        this.isSubmitting = true;
        const formData = this.prepareFormData();
        var podatki = new URLSearchParams();
        podatki.append('podatki', JSON.stringify(formData));
        axios.post('./api/pregledi/povrsina/vnos/', podatki, {withCredentials: true}).then((response) => {
          this.getDailyDocument();
          this.text = this.$t('obvestila.zapisDodan');
          this.types = 'Uspešno';
          this.ShowNoti = true;
        }).catch((napaka) => {
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = this.$t('obvestila.napakaVnosa');
          } else {
            this.text = this.$t('obvestila.napakaVnosa');
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
          this.ErrorReport('napaka-pregled-povrsin-vnos', '/api/pregledi/povrsina/vnos/', 'submitForm()', 'pregled-povrsin-vnos', this.text);
        });
        // Simulate API call
        // await new Promise(resolve => setTimeout(resolve, 1000));

        // this.text = 'Form submitted successfully';
        // this.types = 'success';
        // this.ShowNoti = true;

        return true;
      } catch (error) {
        this.text = 'Error submitting form: ' + error.message;
        this.types = 'error';
        this.ShowNoti = true;
        return false;
      } finally {
        this.isSubmitting = false;
      }
    },
    downloadDocument() {
      window.open('./' + this.dailyDocument);
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
    ErrorReport(imeEventa, endpoint = null, metoda = null, imeNapake = null, opisNapake = null) {
      window.umami.track(imeEventa, {
        endpoint: endpoint,
        metoda: metoda,
        akcija: imeNapake,
        opis: opisNapake
      });
    }
  }
}
</script>
<template>
  <div class="pregled-povrsin-container" v-if="prevodi">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>{{$t('main.nazaj')}}</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">{{$t('main.title')}}</h1>
          <p class="page-subtitle">{{$t('main.subtitle')}}</p>
        </div>

        <!-- Navigation Tabs -->
        <div class="header-section header-right">
          <div class="nav-tabs">
            <button class="nav-tab" :class="{'active': prikaz === 'vnos'}" @click="prikaz = 'vnos'" data-umami-event="PregledPovršin-vnos">
              <i class="fas fa-edit"></i>
              <span>{{$t('nav.vnos')}}</span>
            </button>
            <button class="nav-tab hover-rdeca" :class="{'active bg-rdeca': prikaz === 'zapisi'}" @click="prikaz = 'zapisi'" data-umami-event="PregledPovršin-zapisi">
              <i class="fas fa-list"></i>
              <span>{{$t('nav.zapisi')}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <main class="main-content" v-if="prikaz === 'vnos'">
      <div class="form-section" v-if="dailyDocument !== ''">
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-info-circle"></i>
          </div>
          <div class="section-title">
            <h3>{{$t('main.titleOddan')}}</h3>
            <!-- <p>Osnovne informacije o letališču</p> -->
          </div>
        </div>
        <div class="section-content">
          <p class='text-danger'>{{$t('main.contentOddan')}}</p>
        </div>
      </div>
      <!-- Section A: Aerodrome Information -->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-plane-departure"></i>
          </div>
          <div class="section-title">
            <h3>{{$t('obrazecA.title')}}</h3>
            <p>{{$t('obrazecA.description')}}</p>
          </div>
        </div>
        <div class="section-content">
          <div class="form-grid">
            <div class="form-group">
              <label class="form-label">{{$t('obrazecA.formLabel1')}}</label>
              <input type="text"
                     v-model="aerodrome.icaoCode"
                     class="form-input"
                     :class="{'error': getFieldError('icaoCode')}"
                     maxlength="4"
                     placeholder="LJAJ" />
              <div class="error-message" v-if="getFieldError('icaoCode')">
                {{ getFieldError('icaoCode') }}
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">{{$t('obrazecA.formLabel2')}}</label>
              <input type="text"
                     v-model="aerodrome.name"
                     class="form-input"
                     placeholder="Ljubljana Airport" />
            </div>
          </div>
        </div>
      </div>

      <!-- Section B: Inspection Date/Time -->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-clock"></i>
          </div>
          <div class="section-title">
            <h3>{{$t('obrazecB.title')}}</h3>
            <p>{{$t('obrazecB.description')}}</p>
          </div>
        </div>
        <div class="section-content">
          <div class="form-grid">
            <div class="form-group">
              <label class="form-label">{{$t('obrazecB.formLabel1')}}</label>
              <input type="text"
                     v-model="inspection.date"
                     class="form-input"
                     :class="{'error': getFieldError('date')}"
                     placeholder="19.10.2025" />
              <div class="error-message" v-if="getFieldError('date')">
                {{ getFieldError('date') }}
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">{{$t('obrazecB.formLabel2')}}</label>
              <input type="text"
                     v-model="inspection.time"
                     class="form-input"
                     :class="{'error': getFieldError('time')}"
                     placeholder="1150" />
              <div class="error-message" v-if="getFieldError('time')">
                {{ getFieldError('time') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Section C: Runway Designation -->
      <div class="form-section" >
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-road"></i>
          </div>
          <div class="section-title">
            <h3>{{$t('obrazecC.title')}}</h3>
            <p>{{$t('obrazecC.description')}}</p>
          </div>
        </div>
        <div class="section-content">
          <div class="form-grid">
            <div class="form-group">
              <label class="form-label">{{$t('obrazecC.formLabel1')}}</label>
              <input type="text"
                     v-model="runway.designation"
                     class="form-input"
                     :class="{'error': getFieldError('designation')}"
                     placeholder="08-26" />
              <div class="error-message" v-if="getFieldError('designation')">
                {{ getFieldError('designation') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 1: Surface Conditions -->
      <div class="form-section" >
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-cloud-rain"></i>
          </div>
          <div class="section-title">
            <h3>{{$t('obrazec1.title')}}</h3>
            <p>{{$t('obrazec1.description')}}</p>
          </div>
        </div>
        <div class="section-content">
          <!-- Desktop Grid View -->
          <div class="desktop-grid">
            <div class="grid-container">
              <!-- Header row -->
              <div class="grid-header">
                <div class="grid-cell surface-label">{{$t('obrazec1.surfaceLabel')}}</div>
                <div class="grid-cell text-center">{{$t('obrazec1.vse')}}</div>
                <div class="grid-cell text-center">I</div>
                <div class="grid-cell text-center">II</div>
                <div class="grid-cell text-center">III</div>
                <div class="grid-cell text-center">A</div>
                <div class="grid-cell text-center">B</div>
                <div class="grid-cell text-center">C</div>
                <div class="grid-cell text-center">{{$t('obrazec1.ploscadi')}}</div>
              </div>

              <!-- Condition rows -->
              <div class="grid-row" v-for="(condition, key) in surfaceConditions.conditions" :key="key">
                <div class="grid-cell surface-label">{{ conditionLabels[key] }}</div>
                <div class="grid-cell text-center">
                  <input type="checkbox"
                         v-model="condition.areas.all"
                         @change="toggleAllAreas(key)"
                         class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="condition.areas.runwayThirds.I" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="condition.areas.runwayThirds.II" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="condition.areas.runwayThirds.III" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="condition.areas.taxiways.A" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="condition.areas.taxiways.B" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="condition.areas.taxiways.C" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="condition.areas.aprons.apron" class="checkbox-input" />
                </div>
              </div>
            </div>
          </div>

          <!-- Mobile/Tablet Multi-Select View -->
          <div class="mobile-multiselect">
            <div class="condition-item" v-for="(condition, key) in surfaceConditions.conditions" :key="key">
              <div class="condition-header">
                <h4>{{ conditionLabels[key] }}</h4>
                <div class="condition-toggle">
                  <input type="checkbox"
                         v-model="condition.areas.all"
                         @change="toggleAllAreas(key)"
                         class="checkbox-input" />
                  <label>Vsa območja</label>
                </div>
              </div>

              <div class="area-selection" v-if="!condition.areas.all">
                <div class="area-group">
                  <h5>Steze (I, II, III)</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="condition.areas.runwayThirds.I" />
                      <span>I</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="condition.areas.runwayThirds.II" />
                      <span>II</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="condition.areas.runwayThirds.III" />
                      <span>III</span>
                    </label>
                  </div>
                </div>

                <div class="area-group">
                  <h5>Vozne steze (A, B, C)</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="condition.areas.taxiways.A" />
                      <span>A</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="condition.areas.taxiways.B" />
                      <span>B</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="condition.areas.taxiways.C" />
                      <span>C</span>
                    </label>
                  </div>
                </div>

                <div class="area-group">
                  <h5>Ploščadi</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="condition.areas.aprons.apron" />
                      <span>Ploščadi</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 3: Deficiencies -->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <div class="section-title">
            <h3>{{$t('obrazec3.title')}}</h3>
            <p>{{$t('obrazec3.description')}}</p>
          </div>
        </div>
        <div class="section-content">
          <!-- Desktop Grid View -->
          <div class="desktop-grid">
            <div class="grid-container">
              <!-- Header row -->
              <div class="grid-header">
                <div class="grid-cell surface-label">{{$t('obrazec3.surfaceLabel')}}</div>
                <div class="grid-cell text-center">{{$t('obrazec3.vse')}}</div>
                <div class="grid-cell text-center">I</div>
                <div class="grid-cell text-center">II</div>
                <div class="grid-cell text-center">III</div>
                <div class="grid-cell text-center">A</div>
                <div class="grid-cell text-center">B</div>
                <div class="grid-cell text-center">C</div>
                <div class="grid-cell text-center">{{$t('obrazec3.ploscadi')}}</div>
              </div>

              <!-- Deficiency rows -->
              <div class="grid-row" v-for="(deficiency, key) in deficiencies" :key="key">
                <div class="grid-cell surface-label">{{ deficiencyLabels[key] }}</div>
                <div class="grid-cell text-center">
                  <input type="checkbox"
                         v-model="deficiency.areas.all"
                         @change="toggleAllAreasDeficiency(key)"
                         class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="deficiency.areas.runwayThirds.I" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="deficiency.areas.runwayThirds.II" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="deficiency.areas.runwayThirds.III" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="deficiency.areas.taxiways.A" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="deficiency.areas.taxiways.B" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="deficiency.areas.taxiways.C" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="deficiency.areas.aprons.apron" class="checkbox-input" />
                </div>
              </div>
            </div>
          </div>

          <!-- Mobile/Tablet Multi-Select View -->
          <div class="mobile-multiselect">
            <div class="deficiency-item" v-for="(deficiency, key) in deficiencies" :key="key">
              <div class="deficiency-header">
                <h4>{{ deficiencyLabels[key] }}</h4>
                <div class="deficiency-toggle">
                  <input type="checkbox"
                         v-model="deficiency.areas.all"
                         @change="toggleAllAreasDeficiency(key)"
                         class="checkbox-input" />
                  <label>Vsa območja</label>
                </div>
              </div>

              <div class="area-selection" v-if="!deficiency.areas.all">
                <div class="area-group">
                  <h5>Steze (I, II, III)</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="deficiency.areas.runwayThirds.I" />
                      <span>I</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="deficiency.areas.runwayThirds.II" />
                      <span>II</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="deficiency.areas.runwayThirds.III" />
                      <span>III</span>
                    </label>
                  </div>
                </div>

                <div class="area-group">
                  <h5>Vozne steze (A, B, C)</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="deficiency.areas.taxiways.A" />
                      <span>A</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="deficiency.areas.taxiways.B" />
                      <span>B</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="deficiency.areas.taxiways.C" />
                      <span>C</span>
                    </label>
                  </div>
                </div>

                <div class="area-group">
                  <h5>Ploščadi</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="deficiency.areas.aprons.apron" />
                      <span>Ploščadi</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 4: Obstacles -->
      <div class="form-section" >
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-exclamation-circle"></i>
          </div>
          <div class="section-title">
            <h3>{{$t('obrazec4.title')}}</h3>
            <p>{{$t('obrazec4.description')}}</p>
          </div>
        </div>
        <div class="section-content">
          <!-- Desktop Grid View -->
          <div class="desktop-grid">
            <div class="grid-container">
              <!-- Header row -->
              <div class="grid-header">
                <div class="grid-cell surface-label">{{$t('obrazec4.surfaceLabel')}}</div>
                <div class="grid-cell text-center">{{$t('obrazec4.vse')}}</div>
                <div class="grid-cell text-center">I</div>
                <div class="grid-cell text-center">II</div>
                <div class="grid-cell text-center">III</div>
                <div class="grid-cell text-center">A</div>
                <div class="grid-cell text-center">B</div>
                <div class="grid-cell text-center">C</div>
                <div class="grid-cell text-center">{{$t('obrazec4.ploscadi')}}</div>
              </div>

              <!-- Obstacles row -->
              <div class="grid-row">
                <div class="grid-cell surface-label">{{$t('obrazec4.surfaceLabel')}}</div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="obstacles.areas.all" @change="toggleAllAreasSection('obstacles')" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="obstacles.areas.runwayThirds.I" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="obstacles.areas.runwayThirds.II" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="obstacles.areas.runwayThirds.III" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="obstacles.areas.taxiways.A" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="obstacles.areas.taxiways.B" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="obstacles.areas.taxiways.C" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="obstacles.areas.aprons.apron" class="checkbox-input" />
                </div>
              </div>
            </div>
          </div>

          <!-- Mobile/Tablet Multi-Select View -->
          <div class="mobile-multiselect">
            <div class="obstacle-item">
              <div class="obstacle-header">
                <h4>Obstacles present</h4>
                <div class="obstacle-toggle">
                  <input type="checkbox"
                         v-model="obstacles.areas.all"
                         @change="toggleAllAreasSection('obstacles')"
                         class="checkbox-input" />
                  <label>Vsa območja</label>
                </div>
              </div>

              <div class="area-selection" v-if="!obstacles.areas.all">
                <div class="area-group">
                  <h5>Steze (I, II, III)</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="obstacles.areas.runwayThirds.I" />
                      <span>I</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="obstacles.areas.runwayThirds.II" />
                      <span>II</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="obstacles.areas.runwayThirds.III" />
                      <span>III</span>
                    </label>
                  </div>
                </div>

                <div class="area-group">
                  <h5>Vozne steze (A, B, C)</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="obstacles.areas.taxiways.A" />
                      <span>A</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="obstacles.areas.taxiways.B" />
                      <span>B</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="obstacles.areas.taxiways.C" />
                      <span>C</span>
                    </label>
                  </div>
                </div>

                <div class="area-group">
                  <h5>Ploščadi</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="obstacles.areas.aprons.apron" />
                      <span>Ploščadi</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 5: Bird Presence -->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-dove"></i>
          </div>
          <div class="section-title">
            <h3>{{$t('obrazec5.title')}}</h3>
            <p>{{$t('obrazec5.description')}}</p>
          </div>
        </div>
        <div class="section-content">
          <!-- Desktop Grid View -->
          <div class="desktop-grid">
            <div class="grid-container">
              <!-- Header row -->
              <div class="grid-header">
                <div class="grid-cell surface-label">{{$t('obrazec5.surfaceLabel')}}</div>
                <div class="grid-cell text-center">{{$t('obrazec5.vse')}}</div>
                <div class="grid-cell text-center">I</div>
                <div class="grid-cell text-center">II</div>
                <div class="grid-cell text-center">III</div>
                <div class="grid-cell text-center">A</div>
                <div class="grid-cell text-center">B</div>
                <div class="grid-cell text-center">C</div>
                <div class="grid-cell text-center">{{$t('obrazec5.ploscadi')}}</div>
              </div>

              <!-- Birds row -->
              <div class="grid-row">
                <div class="grid-cell surface-label">{{$t('obrazec5.gridLabel')}}</div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="birds.areas.all" @change="toggleAllAreasSection('birds')" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="birds.areas.runwayThirds.I" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="birds.areas.runwayThirds.II" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="birds.areas.runwayThirds.III" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="birds.areas.taxiways.A" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="birds.areas.taxiways.B" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="birds.areas.taxiways.C" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="birds.areas.aprons.apron" class="checkbox-input" />
                </div>
              </div>
            </div>
          </div>

          <!-- Mobile/Tablet Multi-Select View -->
          <div class="mobile-multiselect">
            <div class="bird-item">
              <div class="bird-header">
                <h4>Birds present</h4>
                <div class="bird-toggle">
                  <input type="checkbox"
                         v-model="birds.areas.all"
                         @change="toggleAllAreasSection('birds')"
                         class="checkbox-input" />
                  <label>Vsa območja</label>
                </div>
              </div>

              <div class="area-selection" v-if="!birds.areas.all">
                <div class="area-group">
                  <h5>Steze (I, II, III)</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="birds.areas.runwayThirds.I" />
                      <span>I</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="birds.areas.runwayThirds.II" />
                      <span>II</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="birds.areas.runwayThirds.III" />
                      <span>III</span>
                    </label>
                  </div>
                </div>

                <div class="area-group">
                  <h5>Vozne steze (A, B, C)</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="birds.areas.taxiways.A" />
                      <span>A</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="birds.areas.taxiways.B" />
                      <span>B</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="birds.areas.taxiways.C" />
                      <span>C</span>
                    </label>
                  </div>
                </div>

                <div class="area-group">
                  <h5>Ploščadi</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="birds.areas.aprons.apron" />
                      <span>Ploščadi</span>
                    </label>
                  </div>
                </div>
              </div>

              <!-- Bird Details - neuporabljeno -->
              <!--                             <div class="bird-details" v-if="isAnyAreaSelectedSection('birds')">
                                              <div class="form-grid">
                                                  <div class="form-group">
                                                      <label class="form-label">Species</label>
                                                      <input type="text" v-model="birds.details.species" class="form-input" placeholder="Species (e.g., Seagulls, Crows)" />
                                                  </div>
                                                  <div class="form-group">
                                                      <label class="form-label">Approximate number</label>
                                                      <input type="text" v-model="birds.details.count" class="form-input" placeholder="Approximate number" />
                                                  </div>
                                              </div>

                                              <div class="form-grid">
                                                  <div class="form-group">
                                                      <label class="form-label">Behavior</label>
                                                      <input type="text" v-model="birds.details.behavior" class="form-input" placeholder="Behavior (feeding, flying, etc.)" />
                                                  </div>
                                                  <div class="form-group">
                                                      <label class="form-label">Flight direction</label>
                                                      <input type="text" v-model="birds.details.flightDirection" class="form-input" placeholder="Flight direction" />
                                                  </div>
                                              </div>

                                              <div class="form-grid">
                                                  <div class="form-group">
                                                      <label class="form-label">Specific area</label>
                                                      <input type="text" v-model="birds.location.specificArea" class="form-input" placeholder="Specific area" />
                                                  </div>
                                                  <div class="form-group">
                                                      <label class="form-label">Flight altitude</label>
                                                      <input type="text" v-model="birds.details.altitude" class="form-input" placeholder="Flight altitude" />
                                                  </div>
                                              </div>

                                              <div class="form-grid">
                                                  <div class="form-group">
                                                      <label class="form-label">Risk Level</label>
                                                      <select v-model="birds.impact.riskLevel" class="form-input">
                                                          <option value="">Risk Level</option>
                                                          <option value="Low">Low</option>
                                                          <option value="Medium">Medium</option>
                                                          <option value="High">High</option>
                                                      </select>
                                                  </div>
                                              </div>

                                              <div class="form-group">
                                                  <label class="form-label">Mitigation measures</label>
                                                  <textarea v-model="birds.impact.mitigation"
                                                            class="form-input"
                                                            rows="3"
                                                            placeholder="Mitigation measures taken..."></textarea>
                                              </div>
                                          </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- Section 6: Remarks -->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-comment-alt"></i>
          </div>
          <div class="section-title">
            <h3>{{$t('obrazec6.title')}}</h3>
            <p>{{$t('obrazec6.description')}}</p>
          </div>
        </div>
        <div class="section-content">
          <!-- Desktop Grid View -->
          <div class="desktop-grid">
            <div class="grid-container">
              <!-- Header row -->
              <div class="grid-header">
                <div class="grid-cell surface-label">{{$t('obrazec6.surfaceLabel')}}</div>
                <div class="grid-cell text-center">{{$t('obrazec6.vse')}}</div>
                <div class="grid-cell text-center">I</div>
                <div class="grid-cell text-center">II</div>
                <div class="grid-cell text-center">III</div>
                <div class="grid-cell text-center">A</div>
                <div class="grid-cell text-center">B</div>
                <div class="grid-cell text-center">C</div>
                <div class="grid-cell text-center">{{$t('obrazec6.ploscadi')}}</div>
              </div>

              <!-- Remarks row -->
              <div class="grid-row">
                <div class="grid-cell surface-label">{{$t('obrazec6.gridLabel')}}</div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="remarks.areas.all" @change="toggleAllAreasSection('remarks')" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="remarks.areas.runwayThirds.I" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="remarks.areas.runwayThirds.II" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="remarks.areas.runwayThirds.III" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="remarks.areas.taxiways.A" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="remarks.areas.taxiways.B" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="remarks.areas.taxiways.C" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="remarks.areas.aprons.apron" class="checkbox-input" />
                </div>
              </div>
              <div class='grid-row'>
                <div class="grid-cell surface-label"></div>
                <div class="grid-cell text-center"></div>
                <!-- VNOS OPOMBE I, II, III-->
                <div class='grid-cell text-center' v-if="remarks.areas.runwayThirds.I">
                  <input type='text' class='input' placeholder="opomba" v-model="remarks.areas.runwayThirds.IRemark" />
                </div>
                <div class='grid-cell text-center' v-if="remarks.areas.runwayThirds.II">
                  <input type='text' class='input' placeholder="opomba" v-model="remarks.areas.runwayThirds.IIRemark" />
                </div>
                <div class='grid-cell text-center' v-if="remarks.areas.runwayThirds.III">
                  <input type='text' class='input' placeholder="opomba" v-model="remarks.areas.runwayThirds.IIIRemark" />
                </div>
                <!-- VNOS OPOMBE A, B, C -->
                <div class='grid-cell text-center' v-if="remarks.areas.taxiways.A">
                  <input type='text' class='input' placeholder="opomba" v-model="remarks.areas.taxiways.ARemark" />
                </div>
                <div class='grid-cell text-center' v-if="remarks.areas.taxiways.B">
                  <input type='text' class='input' placeholder="opomba" v-model="remarks.areas.taxiways.BRemark" />
                </div>
                <div class='grid-cell text-center' v-if="remarks.areas.taxiways.C">
                  <input type='text' class='input' placeholder="opomba" v-model="remarks.areas.taxiways.CRemark" />
                </div>
                <!-- VNOS OPOMBE PLOŠČA -->
                <div class='grid-cell text-center' v-if="remarks.areas.aprons.apron">
                  <input type='text' class='input' placeholder="opomba" v-model="remarks.areas.aprons.Remark" />
                </div>
              </div>
            </div>
          </div>

          <!-- Mobile/Tablet Multi-Select View -->
          <div class="mobile-multiselect">
            <div class="remarks-item">
              <div class="remarks-header">
                <h4>General remarks</h4>
                <div class="remarks-toggle">
                  <input type="checkbox"
                         v-model="remarks.areas.all"
                         @change="toggleAllAreasSection('remarks')"
                         class="checkbox-input" />
                  <label>Vsa območja</label>
                </div>
              </div>

              <div class="area-selection">
                <div class="area-group"  v-if="!remarks.areas.all">
                  <h5>Steze (I, II, III)</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="remarks.areas.runwayThirds.I" />
                      <span>I</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="remarks.areas.runwayThirds.II" />
                      <span>II</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="remarks.areas.runwayThirds.III" />
                      <span>III</span>
                    </label>
                  </div>
                </div>

                <div class="area-group"  v-if="!remarks.areas.all">
                  <h5>Vozne steze (A, B, C)</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="remarks.areas.taxiways.A" />
                      <span>A</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="remarks.areas.taxiways.B" />
                      <span>B</span>
                    </label>
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="remarks.areas.taxiways.C" />
                      <span>C</span>
                    </label>
                  </div>
                </div>

                <div class="area-group"  v-if="!remarks.areas.all">
                  <h5>Ploščadi</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="remarks.areas.aprons.apron" />
                      <span>Ploščadi</span>
                    </label>
                  </div>
                </div>
                <!-- I, II, III -->
                <div class="area-group">
                  <h5 v-if="remarks.areas.runwayThirds.I || remarks.areas.all">Opomba steze</h5>
                  <div class="area-checkboxes" v-if="remarks.areas.runwayThirds.I || remarks.areas.all">
                    <label class="area-checkbox">
                      <input type="text" v-model="remarks.areas.runwayThirds.IRemark" />
                      <span>Opomba I</span>
                    </label>
                  </div>
                  <div class="area-checkboxes" v-if="remarks.areas.runwayThirds.II || remarks.areas.all">
                    <label class="area-checkbox">
                      <input type="text" v-model="remarks.areas.runwayThirds.IIRemark" />
                      <span>Opomba II</span>
                    </label>
                  </div>
                  <div class="area-checkboxes" v-if="remarks.areas.runwayThirds.III || remarks.areas.all">
                    <label class="area-checkbox">
                      <input type="text" v-model="remarks.areas.runwayThirds.IIIRemark" />
                      <span>Opomba III</span>
                    </label>
                  </div>
                </div>
                <!-- A, B, C -->
                <div class="area-group">
                  <h5 v-if="remarks.areas.taxiways.A || remarks.areas.all">Opomba vozne steze</h5>
                  <div class="area-checkboxes" v-if="remarks.areas.taxiways.A || remarks.areas.all">
                    <label class="area-checkbox">
                      <input type="text" v-model="remarks.areas.taxiways.ARemark" />
                      <span>Opomba A</span>
                    </label>
                  </div>
                  <div class="area-checkboxes" v-if="remarks.areas.taxiways.B || remarks.areas.all">
                    <label class="area-checkbox">
                      <input type="text" v-model="remarks.areas.taxiways.BRemark" />
                      <span>Opomba B</span>
                    </label>
                  </div>
                  <div class="area-checkboxes" v-if="remarks.areas.taxiways.C || remarks.areas.all">
                    <label class="area-checkbox">
                      <input type="text" v-model="remarks.areas.taxiways.CRemark" />
                      <span>Opomba C</span>
                    </label>
                  </div>
                </div>
                <!-- PLOŠČA -->
                <div class="area-group">
                  <h5 v-if="remarks.areas.aprons.apron || remarks.areas.all">Opomba ploščad</h5>
                  <div class="area-checkboxes" v-if="remarks.areas.aprons.apron || remarks.areas.all">
                    <label class="area-checkbox">
                      <input type="text" v-model="remarks.areas.aprons.Remark" />
                      <span>Opomba ploščad</span>
                    </label>
                  </div>
                </div>
              </div>

              <!-- Remarks Details - neuporabno -->
              <!--                             <div class="remarks-details">
                                              <div class="form-grid">
                                                  <div class="form-group">
                                                      <label class="form-label">General Operational Information</label>
                                                      <textarea v-model="remarks.general"
                                                                class="form-input"
                                                                rows="3"
                                                                placeholder="Enter any important operational information..."></textarea>
                                                  </div>
                                                  <div class="form-group">
                                                      <label class="form-label">Detailed Deficiency Descriptions</label>
                                                      <textarea v-model="remarks.detailedDeficiencies"
                                                                class="form-input"
                                                                rows="3"
                                                                placeholder="More detailed descriptions of deficiencies from Section 3..."></textarea>
                                                  </div>
                                              </div>

                                              <div class="form-grid">
                                                  <div class="form-group">
                                                      <label class="form-label">Weather Conditions</label>
                                                      <input type="text" v-model="remarks.weatherConditions" class="form-input" placeholder="Weather during inspection" />
                                                  </div>
                                                  <div class="form-group">
                                                      <label class="form-label">Priority Level</label>
                                                      <select v-model="remarks.priority" class="form-input">
                                                          <option value="">Select Priority</option>
                                                          <option value="Low">Low</option>
                                                          <option value="Medium">Medium</option>
                                                          <option value="High">High</option>
                                                          <option value="Critical">Critical</option>
                                                      </select>
                                                  </div>
                                              </div>

                                              <div class="form-grid">
                                                  <div class="form-group">
                                                      <div class="checkbox-item">
                                                          <input type="checkbox" v-model="remarks.followUpRequired" />
                                                          <span>Follow-up action required</span>
                                                      </div>
                                                      <input type="date" v-model="remarks.followUpDate" class="form-input mt-2" v-if="remarks.followUpRequired" />
                                                  </div>
                                                  <div class="form-group">
                                                      <label class="form-label">Inspector Notes</label>
                                                      <textarea v-model="remarks.inspectorNotes"
                                                                class="form-input"
                                                                rows="2"
                                                                placeholder="Additional inspector observations..."></textarea>
                                                  </div>
                                              </div>
                                          </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- Section 7: Helicopter Landing Pad Inspection -->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-helicopter"></i>
          </div>
          <div class="section-title">
            <h3>{{$t('obrazec7.title')}}</h3>
            <p>{{$t('obrazec7.description')}}</p>
          </div>
        </div>
        <div class="section-content">
          <!-- Desktop Grid View -->
          <div class="desktop-grid">
            <div class="grid-container">
              <!-- Header row -->
              <div class="grid-header-helipad">
                <div class="grid-cell surface-label">{{$t('obrazec7.surfaceLabel')}}</div>
                <div class="grid-cell text-center">{{$t('obrazec7.vseOK')}}</div>
                <div class="grid-cell text-center">Vozna steza-zrak (Air Taxiway)</div>
                <div class="grid-cell text-center">Parkirne ploščad (Helipad)</div>
                <div class="grid-cell text-center">Luči (Lights)</div>
                <div class="grid-cell text-center">Dovozna pot (Helipad access road)</div>
              </div>

              <!-- Helicopter pads row -->
              <div class="grid-row-helipad">
                <div class="grid-cell surface-label">{{$t('obrazec7.gridLabel')}}</div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="helicopterPads.areas.all" @change="toggleAllAreasSection('helicopterPads')" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="helicopterPads.areas.airTaxiway.airTaxiway" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="helicopterPads.areas.helipad.helipad" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="helicopterPads.areas.lights.lights" class="checkbox-input" />
                </div>
                <div class="grid-cell text-center">
                  <input type="checkbox" v-model="helicopterPads.areas.helipadAccessRoad.helipadAccessRoad" class="checkbox-input" />
                </div>
              </div>
              <div class='grid-row-helipad'>
                <div class="grid-cell surface-label"></div>
                <div class="grid-cell text-center"></div>
                <div class='grid-cell text-center' v-if="helicopterPads.areas.airTaxiway.airTaxiway">
                  <input type='text' class='input' placeholder="opomba taxiway" v-model="helicopterPads.areas.airTaxiway.airTaxiwayRemark" />
                </div>
                <div class='grid-cell text-center' v-if="helicopterPads.areas.helipad.helipad">
                  <input type='text' class='input' placeholder="opomba helipad" v-model="helicopterPads.areas.helipad.helipadRemark" />
                </div>
                <div class='grid-cell text-center' v-if="helicopterPads.areas.lights.lights">
                  <input type='text' class='input' placeholder="opomba luči" v-model="helicopterPads.areas.lights.lightsRemark" />
                </div>
                <div class='grid-cell text-center' v-if="helicopterPads.areas.helipadAccessRoad.helipadAccessRoad">
                  <input type='text' class='input' placeholder="opomba access road" v-model="helicopterPads.areas.helipadAccessRoad.helipadAccessRoadRemark" />
                </div>
              </div>
            </div>
          </div>

          <!-- Mobile/Tablet Multi-Select View -->
          <div class="mobile-multiselect">
            <div class="helicopter-item">
              <div class="helicopter-header">
                <h4>Helicopter landing pads</h4>
                <div class="helicopter-toggle">
                  <input type="checkbox"
                         v-model="helicopterPads.areas.all"
                         @change="toggleAllAreasSection('helicopterPads')"
                         class="checkbox-input" />
                  <label>Vse ok</label>
                </div>
              </div>

              <div class="area-selection" v-if="!helicopterPads.areas.all">
                <div class="area-group">
                  <h5>Vozna steza-zrak (Air Taxiway)</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="helicopterPads.areas.airTaxiway.airTaxiway" />
                      <span>Vozna steza-zrak (Air Taxiway)</span>
                    </label>
                  </div>
                </div>

                <div class="area-group">
                  <h5>Parkirne ploščad (Helipad)</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="helicopterPads.areas.helipad.helipad" />
                      <span>Parkirne ploščad (Helipad)</span>
                    </label>
                  </div>
                </div>

                <div class="area-group">
                  <h5>Luči (Lights)</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="helicopterPads.areas.lights.lights" />
                      <span>Luči (Lights)</span>
                    </label>
                  </div>
                </div>

                <div class="area-group">
                  <h5>Dovozna pot (Helipad access road)</h5>
                  <div class="area-checkboxes">
                    <label class="area-checkbox">
                      <input type="checkbox" v-model="helicopterPads.areas.helipadAccessRoad.helipadAccessRoad" />
                      <span>Dovozna pot (Helipad access road)</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="area-group">
                <h5>Opomba</h5>
                <div class="area-checkboxes" v-if="helicopterPads.areas.airTaxiway.airTaxiway">
                  <label class="area-checkbox">
                    <input type="text" v-model="helicopterPads.areas.airTaxiway.airTaxiwayRemark" />
                    <span>Opomba taxiway</span>
                  </label>
                </div>
                <div class="area-checkboxes" v-if="helicopterPads.areas.helipad.helipad">
                  <label class="area-checkbox">
                    <input type="text" v-model="helicopterPads.areas.helipad.helipadRemark" />
                    <span>Opomba helipad</span>
                  </label>
                </div>
                <div class="area-checkboxes" v-if="helicopterPads.areas.lights.lights">
                  <label class="area-checkbox">
                    <input type="text" v-model="helicopterPads.areas.lights.lightsRemark" />
                    <span>Opomba luči</span>
                  </label>
                </div>
                <div class="area-checkboxes" v-if="helicopterPads.areas.helipadAccessRoad.helipadAccessRoad">
                  <label class="area-checkbox">
                    <input type="text" v-model="helicopterPads.areas.helipadAccessRoad.helipadAccessRoadRemark" />
                    <span>Opomba access road</span>
                  </label>
                </div>
              </div>

              <!-- Helicopter Pad Details -->
              <!--                             <div class="helicopter-pad-details" v-if="isAnyAreaSelectedSection('helicopterPads')">
                                              <div class="form-grid">
                                                  <div class="form-group">
                                                      <label class="form-label">Pad number/ID</label>
                                                      <input type="text" v-model="helicopterPads.location.padNumber" class="form-input" placeholder="Pad number/ID" />
                                                  </div>
                                                  <div class="form-group">
                                                      <label class="form-label">GPS coordinates</label>
                                                      <input type="text" v-model="helicopterPads.location.coordinates" class="form-input" placeholder="GPS coordinates" />
                                                  </div>
                                              </div>

                                              <div class="form-grid">
                                                  <div class="form-group">
                                                      <label class="form-label">Pad dimensions</label>
                                                      <input type="text" v-model="helicopterPads.location.dimensions" class="form-input" placeholder="Pad dimensions" />
                                                  </div>
                                                  <div class="form-group">
                                                      <label class="form-label">Inspector name</label>
                                                      <input type="text" v-model="helicopterPads.inspection.inspector" class="form-input" placeholder="Inspector name" />
                                                  </div>
                                              </div>

                                              <div class="form-grid">
                                                  <div class="form-group">
                                                      <label class="form-label">Weather conditions</label>
                                                      <input type="text" v-model="helicopterPads.inspection.conditions" class="form-input" placeholder="Weather conditions" />
                                                  </div>
                                                  <div class="form-group">
                                                      <label class="form-label">Pad condition</label>
                                                      <input type="text" v-model="helicopterPads.details.padCondition" class="form-input" placeholder="Pad condition" />
                                                  </div>
                                              </div>

                                              <div class="form-grid">
                                                  <div class="form-group">
                                                      <label class="form-label">Marking condition</label>
                                                      <input type="text" v-model="helicopterPads.details.markings" class="form-input" placeholder="Marking condition" />
                                                  </div>
                                                  <div class="form-group">
                                                      <label class="form-label">Lighting system status</label>
                                                      <input type="text" v-model="helicopterPads.details.lighting" class="form-input" placeholder="Lighting system status" />
                                                  </div>
                                              </div>

                                              <div class="form-group">
                                                  <label class="form-label">Drainage system status</label>
                                                  <input type="text" v-model="helicopterPads.details.drainage" class="form-input" placeholder="Drainage system status" />
                                              </div>

                                              <div class="form-grid">
                                                  <div class="form-group">
                                                      <label class="form-label">Inspection findings</label>
                                                      <textarea v-model="helicopterPads.inspection.findings"
                                                                class="form-input"
                                                                rows="3"
                                                                placeholder="Inspection findings..."></textarea>
                                                  </div>
                                                  <div class="form-group">
                                                      <label class="form-label">Recommendations</label>
                                                      <textarea v-model="helicopterPads.inspection.recommendations"
                                                                class="form-input"
                                                                rows="3"
                                                                placeholder="Recommendations..."></textarea>
                                                  </div>
                                              </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->

      <!-- Form Actions -->
      <div class="form-actions">
        <div class="action-buttons">
          <button type="button"
                  class="btn btn-secondary"
                  @click="clearForm">
            <i class="fas fa-trash"></i>
            <span>{{$t('buttons.pocisti')}}</span>
          </button>
          <button type="button"
                  class="btn btn-primary"
                  @click="submitForm"
                  :disabled="isSubmitting"
                  data-umami-event="PregledPovršin-vnos-dodajanje">
            <i class="fas fa-paper-plane" v-if="!isSubmitting"></i>
            <i class="fas fa-spinner fa-spin" v-if="isSubmitting"></i>
            <span v-if="isSubmitting">{{$t('zapisi.posiljam')}}</span>
            <span v-else>{{$t('buttons.poslji')}}</span>
          </button>
        </div>
      </div>
    </main>

    <!-- Records view -->
    <main class="main-content" v-if="prikaz === 'zapisi'">
      <div class="records-section">
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-list-alt"></i>
          </div>
          <div class="section-title col-10 d-flex justify-content-between">
            <div class='col-8'>
              <h3>{{$t('zapisi.title')}}</h3>
              <p>{{$t('zapisi.description')}}</p>
            </div>
            <div class="col-4 text-white" for="datum">{{$t('labels.datum')}}<br/>
              <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum" :min="new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split('T')[0]" v-model="datum" required @change="CheckDate()"/>
            </div>

          </div>
        </div>
        <div class="section-content" v-if="dailyDocument === '' ">
          <div class="empty-state">
            <i class="pregled-povrsin-ikona fas fa-inbox"></i>
            <h4>{{$t('zapisi.ni')}}</h4>
            <p>{{$t('zapisi.niDescription')}}</p>
          </div>
        </div>
        <div class="section-content" v-else>
          <div class="empty-state">
            <i class="pregled-povrsin-ikona fas fa-inbox"></i>
            <h4>{{new Date(datum).toLocaleDateString('sl-SI')}}</h4>
            <i class="fas fa-info-circle"></i> {{$t('zapisi.info')}} <i class="fas fa-info-circle"></i><br/>
            <button type="button"
                    class="btn btn-primary mb-3"
                    @click="downloadDocument()"
                    data-umami-event="PregledPovršin-zapisi-prenos">
              <i class="fas fa-file-download"></i>
              <span>{{$t('buttons.prenesi')}}</span>
            </button>
            <p><iframe class='pregled-povrsin-dokument' :src="'./'+dailyDocument" /></p>
          </div>
        </div>
      </div>
    </main>

    <!-- ODMIK OD CAPTCHE -->
    <div class='col-12 p-5'></div>

    <!-- Notification -->
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
    </Transition>
  </div>
</template>